(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const preview = document.querySelector('.diagnosis-preview');
    if (!preview) return;

    const hatContainer = preview.querySelector('.diagnosis-preview__hat');
    if (!hatContainer) return;

    // Ensure there's an <img> inside the hat container
    let hatImg = hatContainer.querySelector('img');
    if (!hatImg) {
      hatImg = document.createElement('img');
      hatImg.className = 'diagnosis-preview__hat-img';
      hatImg.loading = 'lazy';
      hatImg.alt = '';
      hatContainer.innerHTML = '';
      hatContainer.appendChild(hatImg);
    }

    const combos = Array.from(
      preview.querySelectorAll('.diagnosis-preview__hat-combo')
    );

    const threadButtons = Array.from(
      document.querySelectorAll('.thread-bar__swatch')
    );

    // Get current thread from first button by default
    let currentThread =
      threadButtons[0]?.dataset.threadColor?.toLowerCase() || null;

    function getSelectedHatColor() {
      // Find the fieldset whose legend is "Color"
      const fieldsets = Array.from(
        document.querySelectorAll('fieldset.product-form__input--pill')
      );

      const colorFieldset = fieldsets.find(fs => {
        const legend = fs.querySelector('legend');
        return (
          legend &&
          legend.textContent.trim().toLowerCase() === 'color'
        );
      });

      if (!colorFieldset) return null;

      const checked = colorFieldset.querySelector(
        'input[type="radio"]:checked'
      );
      return checked ? checked.value.toLowerCase() : null;
    }

    function findCombo(hatColor, threadColor) {
      if (!hatColor || !threadColor) return null;

      return combos.find(combo => {
        const comboHat = combo.dataset.hatColor?.toLowerCase();
        const comboThread = combo.dataset.thread?.toLowerCase();
        return comboHat === hatColor && comboThread === threadColor;
      });
    }

    function updateHat() {
      const hatColor = getSelectedHatColor();
      if (!hatColor) return;

      // Try exact match
      let combo = findCombo(hatColor, currentThread);

      // Fallback: any combo for that hat color
      if (!combo) {
        combo = combos.find(
          c => c.dataset.hatColor?.toLowerCase() === hatColor
        );
      }

      if (!combo) return;

      const src = combo.dataset.imgSrc;
      if (!src) return;

      hatImg.src = src;
      hatImg.alt = `${hatColor} beanie with ${currentThread} thread`;
    }

    // Wire up thread buttons
    threadButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        threadButtons.forEach(b =>
          b.classList.remove('thread-bar__swatch--active')
        );
        btn.classList.add('thread-bar__swatch--active');

        currentThread = btn.dataset.threadColor?.toLowerCase() || null;
        updateHat();
      });
    });

    // Listen for color changes
    const colorFieldsets = Array.from(
      document.querySelectorAll('fieldset.product-form__input--pill')
    );
    const colorFieldset = colorFieldsets.find(fs => {
      const legend = fs.querySelector('legend');
      return (
        legend &&
        legend.textContent.trim().toLowerCase() === 'color'
      );
    });
    if (colorFieldset) {
      colorFieldset.addEventListener('change', updateHat);
    }

    // Kick things off
    if (threadButtons[0]) {
      threadButtons[0].classList.add('thread-bar__swatch--active');
      currentThread =
        threadButtons[0].dataset.threadColor?.toLowerCase() || null;
    }
    updateHat();
  });
})();